import React, { useEffect, useRef, useState } from 'react'
import './CreatePerson.css'
import Personuicomponent from './Personuicomponent'
import {
  initialerror,
  initialpersonValue,
  initialvalueForeditBoolean,
} from '../Data/StaticPersonandMoviedata'
import PersonDataforForm from './PersonDataforForm'
import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import Submiteditperson from './Submiteditperson'
import isDeepEqual from 'fast-deep-equal/react'
import { useHistory } from 'react-router-dom'
import ApproveCreateMoviePerson from '../Movie/ApproveCreateMoviePerson'

export default function CreatePerson(props) {
  // props for this file from parent
  const {
    mode,
    Editmode,
    MultiplePersons,
    personIndex,
    personIndexSelectionObj,
    getInputDataFromCreatePerson,
    MultiplePersonsArray,
  } = props
  // State variables for this file
  const [rendeedPersondata, setrendeedPersondata] = useState('')
  // ====> staic data is used from StaticPersonandMoviedata
  const [initalRender, setIntialRender] = useState(false)
  const [PersoninputData, setInputData] = useState(initialpersonValue)
  const [valueChanged, setValueChanged] = useState(initialvalueForeditBoolean)
  const [inputObject, setInputObject] = useState({})
  const [personName, setpersonName] = useState('')
  const [personNamete, setpersonNamete] = useState('')
  const [shortBio, setShortbio] = useState('')
  const [shortBiote, setShortbiote] = useState('')
  const [wikipediaURL, setWikipediaURL] = useState('')
  const [error, setError] = useState(initialerror)
  const [personNationality, setNationality] = useState('Indian')
  const [personDied, setpersonDied] = useState('')
  const [PersonCurrentlyActive, setPersonCurrentlyActive] = useState('')
  const [status, setStatus] = useState('draft')
  const history = useHistory()
  const personDataForState = {
    personName,
    personNamete,
    shortBio,
    shortBiote,
    wikipediaURL,
    personNationality,
    personDied,
    PersonCurrentlyActive,
  }

  const personDataRef = useRef(PersoninputData)
  if (!isDeepEqual(personDataRef.current, PersoninputData)) {
    personDataRef.current = { ...personDataForState, ...PersoninputData }
  }

  const SubmitPerson = async () => {
    const update = await Submiteditperson(
      {
        mode: props.mode,
        rendeedPersondata,
        ...personDataForState,
        ...PersoninputData,
        personIndexSelectionObj,
        getInputDataFromCreatePerson,
        personIndex,
        valueChanged,
        MultiplePersons,
      },
      props.sendInputCreatePerson,
      sendInputObject,
    )
    if (update !== 'multiplePersons') {
      if (update.statusCode === 'A005') {
        const rendeedPersondataTemp = { ...rendeedPersondata }
        rendeedPersondataTemp.PK = update.PK
        rendeedPersondataTemp.SK = update.SK
        setrendeedPersondata(rendeedPersondataTemp)
      }

      if (update.statusCode === 'A002' || update.statusCode === 'A005') {
      if (EDitApproveOptionBoolean && status === 'draft') {
        setLoadPopup(true)
      } else {
        history.push('/editperson?' + encodeURI(update && update.PK ? update.PK : rendeedPersondata.PK))
        window.location.reload(false)
      }
    }
    }
  }

  const sendInputObject = data => {
    setInputObject(data)
  }

  const sendInitialRender = data => {
    setIntialRender(data)
  }

  const [loadPopup, setLoadPopup] = useState(false)
  const [EDitApproveOptionBoolean, setEDitApproveOptionBoolean] = useState(false)

  // function to call when value is changed or edited
  const sendValuechangedBoolean = (field, data) => {
    const ValueChangedtemp = { ...valueChanged }
    ValueChangedtemp[field] = data
    setValueChanged(ValueChangedtemp)
  }

  // functions for updating person inputdata
  const sendInputPersondata = data => setInputData(data)

  const updateInputPersonData = (fieldname, fieldvalue) => {
    const data = { ...PersoninputData }
    data[fieldname] = fieldvalue

    setInputData(data)
  }

  // function for updating multiple person inputs
  const updateMultipleInputData = input => {
    const data = { ...PersoninputData }
    Object.keys(input).map(keyname => {
      data[keyname] = input[keyname]
      return data[keyname]
    })
    setInputData(data)
  }

  const MultiplePersonsChecked = data => {
    props.MultiplePersonsChecked(personIndex, data)
    setIntialRender(true)
  }

  useEffect(() => {
    if (MultiplePersons && personIndexSelectionObj[personIndex]) {
      SubmitPerson()
    }
  }, [MultiplePersons ? personIndexSelectionObj[personIndex] : ''])

  const DisableCheckBox = () => {
    const disableCheckbox =
      personName &&
      personNamete &&
      PersoninputData.personPoster &&
      shortBio.length > 3 &&
      shortBiote.length > 3 &&
      wikipediaURL.length >= 5

    return disableCheckbox
  }

  const checboxSelect = () => {
    if (DisableCheckBox()) {
      if (personIndexSelectionObj[personIndex]) {
        props.MultiplePersonsChecked(personIndex, false)
      } else {
        props.MultiplePersonsChecked(personIndex, true)
      }
    }
  }

  useEffect(() => {
    const { personData } = props
    const MultiplepersonIndex = MultiplePersonsArray
      ? MultiplePersonsArray.findIndex(item => item.personIndex === personIndex)
      : -1
    if (Object.keys(inputObject).length > 0) {
      const fillpersonData = async () => {
        const inputdata2 = await PersonDataforForm(inputObject ? inputObject : '')
        updateMultipleInputData(inputdata2)
      }

      fillpersonData()
    } else if (MultiplepersonIndex !== -1) {
      setrendeedPersondata(MultiplePersonsArray[MultiplepersonIndex])
      const fillpersonData = async () => {
        const inputdata2 = await PersonDataforForm(
          MultiplePersonsArray[MultiplepersonIndex]
            ? MultiplePersonsArray[MultiplepersonIndex]
            : '',
        )
        updateMultipleInputData(inputdata2)
      }

      fillpersonData()
    } else if (personData) {
      setStatus(personData.status ? personData.status : 'draft')
      setrendeedPersondata(personData)
      const fillpersonData = async () => {
        const inputdata2 = await PersonDataforForm(personData ? personData : '')
        updateMultipleInputData(inputdata2)
      }

      fillpersonData()
    }
  }, [props, props.personData, inputObject])
  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const EDitApproveOption = permissionsArr.includes(
        DefinedPermissions.DisplayApprovePersonOption,
      )
      setEDitApproveOptionBoolean(EDitApproveOption)
    }

    getPermissions()
  }, [])

  /* MultiplePersonsArray */ return (
    <div className='movie1'>
      <div className='movie p-3'>
        {/* depends on the mode it displays edit form or create form */}
        <div className='createmovie'>{props.mode === 'Edit' ? 'Edit Person' : 'Create Person'}</div>
        {/* Ui component for edit and create person */}
        <Personuicomponent
          rendeedPersondata={rendeedPersondata}
          MultiplePersons={MultiplePersons}
          disableInput={MultiplePersons ? personIndexSelectionObj[personIndex] : false}
          PersoninputData={PersoninputData}
          sendInputCreatePerson={props.sendInputCreatePerson}
          personIndex={personIndex}
          getInputDataFromCreatePerson={getInputDataFromCreatePerson}
          valueChanged={valueChanged}
          personIndexSelectionObj={personIndexSelectionObj ? personIndexSelectionObj : {}}
          sendValuechangedBoolean={sendValuechangedBoolean}
          sendInputdata={sendInputPersondata}
          updateInputData={updateInputPersonData}
          sendInputObject={sendInputObject}
          initalRender={initalRender}
          sendInitialRender={sendInitialRender}
          mode={mode}
          Edit={Editmode}
          setLoadPopup={setLoadPopup}
          personName={personName}
          setpersonName={setpersonName}
          personNamete={personNamete}
          setpersonNamete={setpersonNamete}
          shortBio={shortBio}
          setShortbio={setShortbio}
          shortBiote={shortBiote}
          setShortbiote={setShortbiote}
          wikipediaURL={wikipediaURL}
          setWikipediaURL={setWikipediaURL}
          error={error}
          setError={setError}
          personNationality={personNationality}
          setNationality={setNationality}
          personDied={personDied}
          setpersonDied={setpersonDied}
          PersonCurrentlyActive={PersonCurrentlyActive}
          setPersonCurrentlyActive={setPersonCurrentlyActive}
          SubmitPerson={SubmitPerson}
        />
        {/* checkbox for multiple person */}
        {MultiplePersons && (
          <div className='d-flex'>
            <input
              className='personCheckBox'
              type='checkbox'
              value=''
              checked={personIndexSelectionObj[personIndex]}
              onChange={e => {
                MultiplePersonsChecked(e.target.checked)
              }}
              disabled={!DisableCheckBox()}
            />
            <div
              className='form-check-label'
              style={DisableCheckBox() ? { color: 'black' } : { color: 'gray' }}
              onClick={() => checboxSelect()}
            >
              {`${personIndex}:${personName}`}
            </div>
          </div>
        )}
        {loadPopup ? (
          EDitApproveOptionBoolean &&
          loadPopup &&
          status === 'draft' && (
            <ApproveCreateMoviePerson
              loadPopup={loadPopup}
              setLoadPopup={setLoadPopup}
              moviePerson={'person'}
              movieData={rendeedPersondata}
            />
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
